import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
var pause_bars = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size || "60", height: size || "60" }, props),
        React.createElement("rect", { x: "21", y: "19.5", width: "6", height: "22" }),
        React.createElement("rect", { x: "33", y: "19.5", width: "6", height: "22" })));
};
pause_bars.displayName = 'pause-bars';
pause_bars.propTypes = {
    size: PropTypes.string
};
export default pause_bars;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=pause_bars.js.map